
export default {
  name: "SwiperCarrousel",
  props: {
    slides: Array,
    photoSwipeActive: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Fullscreen functionality:
    // When true, display one slide per view and make the slide full width.
    fullScreen: {
      type: Boolean,
      default: false,
      required: false,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      swiper: null,
      // Default options for non-fullScreen mode
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 10,
        slidesPerGroup: 1,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 14,
        loop: false,
        loopFillGroupWithBlank: false,
        // Responsive breakpoints
        breakpoints: {
          320: {
            spaceBetween: 10,
            slidesPerView: 1.15,
            draggable: false,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: "auto",
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 20,
          },
          1220: {
            slidesPerView: "auto",
            spaceBetween: 20,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
          1280: {
            slidesPerView: "auto",
            spaceBetween: 20,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 20,
          },
          1500: {
            slidesPerView: "auto",
            spaceBetween: 20,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeSwiper();
    });
  },
  methods: {
    initializeSwiper() {
      // Use a different configuration if fullScreen is true
      let options;
      if (this.fullScreen) {
        options = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          autoplay: {
            delay: 2000, // 2 seconds
            disableOnInteraction: false,
          },
        }
      } else {
        options = {
          loop: true,
          ...this.swiperOptions,
        };
      }
      this.swiper = new this.$swiper(this.$refs.swiperElement, options);
    },
    triggerSlideCarrousel(directionLeft) {
      if (directionLeft) {
        this.swiper.slideNext();
      } else {
        this.swiper.slidePrev();
      }
    },
  },
};
